import { useEffect, useRef, useState } from 'react';
import { FACILITY_ROLES, roleLabel, roleTone } from '../../utils/facilityRoles';

export default function RolePicker({ currentRole, onChange, disabled = false }) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onDocClick = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    const tone = roleTone(currentRole);

    if (disabled) {
        return (
            <span className={`role-pill role-pill-readonly role-${tone}`}>
                <span className="role-pill-dot" /> {roleLabel(currentRole)}
            </span>
        );
    }

    const handleSelect = (id) => {
        setOpen(false);
        if (id !== currentRole) onChange(id);
    };

    return (
        <div className="role-picker" ref={containerRef}>
            <button
                type="button"
                className={`role-pill role-${tone}`}
                aria-haspopup="listbox"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
            >
                <span className="role-pill-dot" /> {roleLabel(currentRole)}
            </button>
            {open && (
                <ul className="role-menu" role="listbox">
                    {FACILITY_ROLES.map((r) => {
                        const isSelected = r.id === currentRole;
                        return (
                            <li
                                key={r.id}
                                role="option"
                                aria-selected={isSelected}
                                aria-label={r.label}
                                className={`role-menu-item${isSelected ? ' selected' : ''}`}
                                onClick={() => handleSelect(r.id)}
                            >
                                <span className={`role-menu-dot role-dot-${r.tone}`} />
                                <div>
                                    <div className="role-menu-name">{r.label}</div>
                                    <div className="role-menu-desc">{r.description}</div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
